import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const ABB_SHOW_MORE_REQUEST = 'ABB_SHOW_MORE_REQUEST';
export const ABB_SHOW_MORE_ERROR = 'ABB_SHOW_MORE_ERROR';
export const ABB_SHOW_MORE_SUCCESS = 'ABB_SHOW_MORE_SUCCESS';

export function abbShowMoreRequestAction() {
	return { type: ABB_SHOW_MORE_REQUEST };
}

export function abbShowMoreErrorAction(error) {
	return { type: ABB_SHOW_MORE_ERROR, error };
}

export function abbShowMoreSuccessAction(data) {
	return { type: ABB_SHOW_MORE_SUCCESS, data };
}

export function fetchBuyBackShowMoreAction(url, requestHeaders = {}) {
	return (dispatch, getState) => {
		dispatch(abbShowMoreRequestAction());
		ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api${url}`,
				headers: Object.assign({}, headers, requestHeaders)
			})
		)
			.then(data => {
				return dispatch(abbShowMoreSuccessAction(data['RESPONSE']));
			})
			.catch(err => {
				dispatch(abbShowMoreErrorAction(err));
				return Promise.reject(err);
			});
	};
}
